var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-page",
    { attrs: { padding: "" } },
    [
      _c(
        "div",
        { staticClass: "q-display-1 q-mb-md text-secondary" },
        [
          _c("q-icon", {
            staticClass: "q-mb-sm",
            attrs: { name: "far fa-user" }
          }),
          _vm._v(" " + _vm._s(_vm.$t("users")) + "\n\t")
        ],
        1
      ),
      _c("filters", {
        staticClass: "filter-card",
        attrs: { options: _vm.getOptionsFilter },
        on: {
          requestFiltered: _vm.requestFiltered,
          clearAndRequest: _vm.clearAndRequest
        }
      }),
      _c("q-table", {
        attrs: {
          data: _vm.users,
          columns: _vm.columns,
          pagination: _vm.server_pagination,
          loading: _vm.loading,
          filter: _vm.filter,
          "row-key": "name",
          "no-data-label": _vm.$t("no_data_avaliable"),
          "no-results-label": _vm.$t("no_results_found"),
          "loading-label": _vm.$t("loading_data"),
          "rows-per-page-label": _vm.$t("items_per_page"),
          "rows-per-page-options": [5, 10, 50, 100],
          "binary-state-sort": ""
        },
        on: {
          "update:pagination": function($event) {
            _vm.server_pagination = $event
          },
          request: _vm.request
        },
        scopedSlots: _vm._u([
          {
            key: "top",
            fn: function(props) {
              return [
                _c("q-search", {
                  attrs: {
                    debounce: 1500,
                    icon: "fas fa-search",
                    placeholder: _vm.$t("search")
                  },
                  model: {
                    value: _vm.filter,
                    callback: function($$v) {
                      _vm.filter = $$v
                    },
                    expression: "filter"
                  }
                }),
                _c("div", { staticClass: "col" }),
                _vm.reportsPermission
                  ? _c(
                      "q-btn",
                      {
                        staticClass: "q-mr-sm",
                        attrs: {
                          color: "secondary",
                          icon: "fas fa-download",
                          disable: _vm.$buttonDelay(
                            "users_report_button_delay"
                          ),
                          label: _vm.$t("user_reports")
                        },
                        on: {
                          click: function($event) {
                            return _vm.downloadReport()
                          }
                        }
                      },
                      [
                        _vm.$buttonDelay("users_report_button_delay")
                          ? _c(
                              "q-tooltip",
                              {
                                attrs: {
                                  anchor: "top middle",
                                  self: "bottom middle",
                                  offset: [10, 10]
                                }
                              },
                              [
                                _vm._v(
                                  "\n\t\t\t\t\t" +
                                    _vm._s(_vm.$t("report_button_delay")) +
                                    "\n\t\t\t\t"
                                )
                              ]
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  : _vm._e(),
                _c("q-btn", {
                  attrs: {
                    color: "secondary",
                    disable: _vm.managerUser,
                    icon: "fas fa-plus",
                    label: _vm.$t("new")
                  },
                  on: {
                    click: function($event) {
                      return _vm.$router.push({
                        name: "admin_user",
                        params: { id: 0 }
                      })
                    }
                  }
                })
              ]
            }
          },
          {
            key: "header",
            fn: function(props) {
              return _c(
                "q-tr",
                { attrs: { props: props } },
                _vm._l(props.cols, function(col) {
                  return _c(
                    "q-th",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.showHeader(col),
                          expression: "showHeader(col)"
                        }
                      ],
                      key: col.name,
                      attrs: { props: props }
                    },
                    [
                      _vm._v(
                        "\n\t\t\t\t" + _vm._s(_vm.$t(col.label)) + "\n\t\t\t"
                      )
                    ]
                  )
                }),
                1
              )
            }
          },
          {
            key: "body",
            fn: function(props) {
              return _c(
                "q-tr",
                { attrs: { props: props } },
                [
                  _c(
                    "q-td",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.showColumn(props.colsMap, "id"),
                          expression: "showColumn(props.colsMap, 'id')"
                        }
                      ],
                      key: "id",
                      attrs: { "auto-width": "", props: props }
                    },
                    [_vm._v("\n\t\t\t\t" + _vm._s(props.row.id) + "\n\t\t\t")]
                  ),
                  _c(
                    "q-td",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.showColumn(props.colsMap, "full_name"),
                          expression: "showColumn(props.colsMap, 'full_name')"
                        }
                      ],
                      key: "full_name",
                      attrs: { props: props }
                    },
                    [
                      _vm._v(
                        "\n\t\t\t\t" + _vm._s(props.row.full_name) + "\n\t\t\t"
                      )
                    ]
                  ),
                  _c(
                    "q-td",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.showColumn(props.colsMap, "gender"),
                          expression: "showColumn(props.colsMap, 'gender')"
                        }
                      ],
                      key: "gender",
                      attrs: { props: props }
                    },
                    [
                      _vm._v(
                        "\n\t\t\t\t" +
                          _vm._s(_vm.$t(props.row.gender)) +
                          "\n\t\t\t"
                      )
                    ]
                  ),
                  _c(
                    "q-td",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.showColumn(props.colsMap, "document"),
                          expression: "showColumn(props.colsMap, 'document')"
                        }
                      ],
                      key: "document",
                      attrs: { props: props }
                    },
                    [
                      _vm._v(
                        "\n\t\t\t\t" + _vm._s(props.row.document) + "\n\t\t\t"
                      )
                    ]
                  ),
                  _c(
                    "q-td",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.showColumn(props.colsMap, "email"),
                          expression: "showColumn(props.colsMap, 'email')"
                        }
                      ],
                      key: "email",
                      attrs: { props: props }
                    },
                    [
                      _vm._v(
                        "\n\t\t\t\t" + _vm._s(props.row.email) + "\n\t\t\t"
                      )
                    ]
                  ),
                  _c(
                    "q-td",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.showColumn(props.colsMap, "birthday"),
                          expression: "showColumn(props.colsMap, 'birthday')"
                        }
                      ],
                      key: "birthday",
                      attrs: { props: props }
                    },
                    [
                      _vm._v(
                        "\n\t\t\t\t" + _vm._s(props.row.birthday) + "\n\t\t\t"
                      )
                    ]
                  ),
                  _c(
                    "q-td",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.showColumn(props.colsMap, "date_joined"),
                          expression: "showColumn(props.colsMap, 'date_joined')"
                        }
                      ],
                      key: "date_joined",
                      attrs: { props: props }
                    },
                    [
                      _vm._v(
                        "\n\t\t\t\t" +
                          _vm._s(props.row.date_joined) +
                          "\n\t\t\t"
                      )
                    ]
                  ),
                  _c(
                    "q-td",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.showColumn(props.colsMap, "date_updated"),
                          expression:
                            "showColumn(props.colsMap, 'date_updated')"
                        }
                      ],
                      key: "date_updated",
                      attrs: { props: props }
                    },
                    [
                      _vm._v(
                        "\n\t\t\t\t" +
                          _vm._s(props.row.date_updated) +
                          "\n\t\t\t"
                      )
                    ]
                  ),
                  _c(
                    "q-td",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.showColumn(
                            props.colsMap,
                            "user_clients__profile"
                          ),
                          expression:
                            "showColumn(props.colsMap, 'user_clients__profile')"
                        }
                      ],
                      key: "user_clients__profile",
                      attrs: { props: props }
                    },
                    [
                      _vm._v(
                        "\n\t\t\t\t" +
                          _vm._s(_vm.translateProfiles(props.row.profile)) +
                          "\n\t\t\t"
                      )
                    ]
                  ),
                  _c(
                    "q-td",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value:
                            _vm.current_client === "Chevrolet" &&
                            _vm.showColumn(props.colsMap, "main_area"),
                          expression:
                            "\n\t\t\t\t\tcurrent_client === 'Chevrolet' && showColumn(props.colsMap, 'main_area')\n\t\t\t\t"
                        }
                      ],
                      key: "main_area",
                      attrs: { props: props }
                    },
                    [
                      _vm._v(
                        "\n\t\t\t\t" +
                          _vm._s(_vm.getMainArea(props.row.main_area)) +
                          "\n\t\t\t"
                      )
                    ]
                  ),
                  _c(
                    "q-td",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.showColumn(props.colsMap, "companies"),
                          expression: "showColumn(props.colsMap, 'companies')"
                        }
                      ],
                      key: "companies",
                      attrs: { props: props }
                    },
                    [
                      props.row.companies.length === 1
                        ? [
                            _vm._v(
                              "\n\t\t\t\t\t" +
                                _vm._s(
                                  props.row.companies[0].name +
                                    " " +
                                    (props.row.companies[0].document
                                      ? "- "
                                      : "") +
                                    " " +
                                    (props.row.companies[0].document
                                      ? props.row.companies[0].document
                                      : "") +
                                    "  " +
                                    (props.row.companies[0].register
                                      ? "- "
                                      : "") +
                                    " " +
                                    (props.row.companies[0].register
                                      ? props.row.companies[0].register
                                      : "")
                                ) +
                                "\n\t\t\t\t"
                            )
                          ]
                        : _vm._e(),
                      props.row.companies.length > 1
                        ? [
                            _c(
                              "q-btn",
                              {
                                attrs: {
                                  color: "primary",
                                  "text-color": "white",
                                  label: props.row.companies.length,
                                  "no-ripple": ""
                                }
                              },
                              [
                                _c("q-tooltip", [
                                  _c(
                                    "p",
                                    { staticClass: "tooltip q-mb-sm" },
                                    _vm._l(props.row.companies, function(
                                      branch,
                                      index
                                    ) {
                                      return _c("span", { key: index }, [
                                        _vm._v(
                                          "\n\t\t\t\t\t\t\t\t\t" +
                                            _vm._s(
                                              branch.name +
                                                " " +
                                                (branch.document ? "- " : "") +
                                                " " +
                                                (branch.document
                                                  ? branch.document
                                                  : "") +
                                                "  " +
                                                (branch.register ? "- " : "") +
                                                " " +
                                                (branch.register
                                                  ? branch.register
                                                  : "")
                                            ) +
                                            "\n\t\t\t\t\t\t\t\t\t"
                                        ),
                                        props.row.companies.length - 1 > index
                                          ? _c("br")
                                          : _vm._e()
                                      ])
                                    }),
                                    0
                                  )
                                ])
                              ],
                              1
                            )
                          ]
                        : _vm._e()
                    ],
                    2
                  ),
                  _c(
                    "q-td",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.showColumn(props.colsMap, "branches"),
                          expression: "showColumn(props.colsMap, 'branches')"
                        }
                      ],
                      key: "branches",
                      attrs: { props: props }
                    },
                    [
                      props.row.branches.length === 1
                        ? [
                            _vm._v(
                              "\n\t\t\t\t\t" +
                                _vm._s(
                                  props.row.branches[0].name +
                                    " " +
                                    (props.row.branches[0].document
                                      ? "- "
                                      : "") +
                                    " " +
                                    (props.row.branches[0].document
                                      ? props.row.branches[0].document
                                      : "") +
                                    "  " +
                                    (props.row.branches[0].register
                                      ? "- "
                                      : "") +
                                    " " +
                                    (props.row.branches[0].register
                                      ? props.row.branches[0].register
                                      : "")
                                ) +
                                "\n\t\t\t\t"
                            )
                          ]
                        : _vm._e(),
                      props.row.branches.length > 1
                        ? [
                            _c(
                              "q-btn",
                              {
                                attrs: {
                                  color: "primary",
                                  "text-color": "white",
                                  label: props.row.branches.length,
                                  "no-ripple": ""
                                }
                              },
                              [
                                _c("q-tooltip", [
                                  _c(
                                    "p",
                                    { staticClass: "tooltip q-mb-sm" },
                                    _vm._l(props.row.branches, function(
                                      branch,
                                      index
                                    ) {
                                      return _c("span", { key: index }, [
                                        _vm._v(
                                          "\n\t\t\t\t\t\t\t\t\t" +
                                            _vm._s(
                                              branch.name +
                                                " " +
                                                (branch.document ? "- " : "") +
                                                " " +
                                                (branch.document
                                                  ? branch.document
                                                  : "") +
                                                "  " +
                                                (branch.register ? "- " : "") +
                                                " " +
                                                (branch.register
                                                  ? branch.register
                                                  : "")
                                            ) +
                                            "\n\t\t\t\t\t\t\t\t\t"
                                        ),
                                        props.row.branches.length - 1 > index
                                          ? _c("br")
                                          : _vm._e()
                                      ])
                                    }),
                                    0
                                  )
                                ])
                              ],
                              1
                            )
                          ]
                        : _vm._e()
                    ],
                    2
                  ),
                  _c(
                    "q-td",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.showColumn(
                            props.colsMap,
                            "branch_regional"
                          ),
                          expression:
                            "showColumn(props.colsMap, 'branch_regional')"
                        }
                      ],
                      key: "branch_regional",
                      attrs: { props: props }
                    },
                    [
                      props.row.branch_regional.length === 1
                        ? [
                            _vm._v(
                              "\n\t\t\t\t\t" +
                                _vm._s("" + props.row.branch_regional[0].name) +
                                "\n\t\t\t\t"
                            )
                          ]
                        : _vm._e(),
                      props.row.branch_regional.length > 1
                        ? [
                            _c(
                              "q-btn",
                              {
                                attrs: {
                                  color: "primary",
                                  "text-color": "white",
                                  label: props.row.branch_regional.length,
                                  "no-ripple": ""
                                }
                              },
                              [
                                _c("q-tooltip", [
                                  _c(
                                    "p",
                                    { staticClass: "tooltip q-mb-sm" },
                                    _vm._l(props.row.branch_regional, function(
                                      branch_regional,
                                      index
                                    ) {
                                      return _c("span", { key: index }, [
                                        _vm._v(
                                          "\n\t\t\t\t\t\t\t\t\t" +
                                            _vm._s("" + branch_regional.name) +
                                            "\n\t\t\t\t\t\t\t\t\t"
                                        ),
                                        props.row.branch_regional.length - 1 >
                                        index
                                          ? _c("br")
                                          : _vm._e()
                                      ])
                                    }),
                                    0
                                  )
                                ])
                              ],
                              1
                            )
                          ]
                        : _vm._e()
                    ],
                    2
                  ),
                  _c(
                    "q-td",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.showColumn(
                            props.colsMap,
                            "accept_terms_date"
                          ),
                          expression:
                            "showColumn(props.colsMap, 'accept_terms_date')"
                        }
                      ],
                      key: "accept_terms_date",
                      attrs: { props: props }
                    },
                    [
                      _vm._v(
                        "\n\t\t\t\t" +
                          _vm._s(props.row.accept_terms_date) +
                          "\n\t\t\t"
                      )
                    ]
                  ),
                  _c(
                    "q-td",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.showColumn(props.colsMap, "status"),
                          expression: "showColumn(props.colsMap, 'status')"
                        }
                      ],
                      key: "status",
                      attrs: { props: props, "auto-width": "" }
                    },
                    [
                      _c(
                        "q-chip",
                        {
                          staticClass: "full-width",
                          attrs: {
                            small: "",
                            icon: _vm.getIconStatus(props.row.status),
                            color: _vm.getColorStatus(props.row.status)
                          }
                        },
                        [
                          _vm._v(
                            "\n\t\t\t\t\t" +
                              _vm._s(_vm.$t(_vm.getStatus(props.row.status))) +
                              "\n\t\t\t\t"
                          )
                        ]
                      )
                    ],
                    1
                  ),
                  _c(
                    "q-td",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.showColumn(props.colsMap, "actions"),
                          expression: "showColumn(props.colsMap, 'actions')"
                        }
                      ],
                      key: "actions",
                      attrs: { props: props }
                    },
                    [
                      _c(
                        "q-btn",
                        {
                          attrs: {
                            flat: "",
                            round: "",
                            color: "secondary",
                            icon: "far fa-list-alt"
                          },
                          on: {
                            click: function() {
                              _vm.view_redeem_statement = true
                              _vm.selected_user = props.row
                              _vm.fetchRedeemStatementByUser({
                                pagination: _vm.redeem_statement_pagination
                              })
                            }
                          }
                        },
                        [
                          _c("q-tooltip", [
                            _vm._v(
                              "\n\t\t\t\t\t\t" +
                                _vm._s(_vm.$t("view_redeem_history_tooltip")) +
                                "\n\t\t\t\t\t"
                            )
                          ])
                        ],
                        1
                      ),
                      _c(
                        "q-btn",
                        {
                          attrs: {
                            flat: "",
                            round: "",
                            color: "secondary",
                            icon: "far fa-id-card"
                          },
                          on: {
                            click: function($event) {
                              return _vm.showReport(props.row)
                            }
                          }
                        },
                        [
                          _c("q-tooltip", [
                            _vm._v(
                              "\n\t\t\t\t\t\t" +
                                _vm._s(_vm.$t("view_profile_tooltip")) +
                                "\n\t\t\t\t\t"
                            )
                          ])
                        ],
                        1
                      ),
                      _c(
                        "q-btn",
                        {
                          attrs: {
                            flat: "",
                            round: "",
                            color: "primary",
                            icon: "fas fa-pencil-alt"
                          },
                          on: {
                            click: function($event) {
                              return _vm.$router.push({
                                name: "admin_user",
                                params: { id: props.row.actions }
                              })
                            }
                          }
                        },
                        [
                          _c("q-tooltip", [
                            _vm._v(
                              "\n\t\t\t\t\t\t" +
                                _vm._s(_vm.$t("view_or_edit_tooltip")) +
                                "\n\t\t\t\t\t"
                            )
                          ])
                        ],
                        1
                      ),
                      _c(
                        "q-btn",
                        {
                          attrs: {
                            flat: "",
                            disable: _vm.managerUserDelete,
                            round: "",
                            color: "negative",
                            icon: "far fa-trash-alt"
                          },
                          on: {
                            click: function($event) {
                              return _vm.confirmRemove(props.row.actions)
                            }
                          }
                        },
                        [
                          _c("q-tooltip", [
                            _vm._v(
                              "\n\t\t\t\t\t\t" +
                                _vm._s(_vm.$t("delete_tooltip")) +
                                "\n\t\t\t\t\t"
                            )
                          ])
                        ],
                        1
                      ),
                      _c(
                        "q-btn",
                        {
                          attrs: {
                            flat: "",
                            disable:
                              _vm.managerUser ||
                              _vm.checkGeneratedEmail(props.row),
                            round: "",
                            color: "info",
                            icon: "fas fa-key"
                          },
                          on: {
                            click: function($event) {
                              return _vm.confirmResetPassword(props.row.actions)
                            }
                          }
                        },
                        [
                          _c("q-tooltip", [
                            _vm._v(
                              "\n\t\t\t\t\t\t" +
                                _vm._s(_vm.$t("reset_password_tooltip")) +
                                "\n\t\t\t\t\t"
                            )
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            }
          },
          {
            key: "bottom-row",
            fn: function(props) {
              return _c(
                "q-tr",
                { attrs: { props: props } },
                [
                  _c(
                    "q-td",
                    { attrs: { colspan: "100%" } },
                    [
                      _c(
                        "q-btn",
                        {
                          attrs: {
                            flat: "",
                            round: "",
                            dense: "",
                            color: "secondary",
                            size: "small",
                            icon: "fas fa-cog"
                          },
                          on: {
                            click: function($event) {
                              _vm.show_modal = true
                            }
                          }
                        },
                        [
                          _c("q-tooltip", [
                            _vm._v(
                              "\n\t\t\t\t\t\t" +
                                _vm._s(_vm.$t("configure_table_tooltip")) +
                                "\n\t\t\t\t\t"
                            )
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            }
          }
        ])
      }),
      _c(
        "q-modal",
        {
          attrs: {
            "content-css": {
              minWidth: _vm.getMinWidth,
              maxWidth: _vm.getMaxWidth,
              minHeight: "80vh"
            }
          },
          model: {
            value: _vm.show_modal,
            callback: function($$v) {
              _vm.show_modal = $$v
            },
            expression: "show_modal"
          }
        },
        [
          _c(
            "q-modal-layout",
            [
              _c(
                "q-toolbar",
                { attrs: { slot: "header" }, slot: "header" },
                [
                  _c("q-btn", {
                    attrs: {
                      flat: "",
                      round: "",
                      dense: "",
                      icon: "fas fa-times"
                    },
                    on: {
                      click: function($event) {
                        return _vm.saveColumns()
                      }
                    }
                  }),
                  _c("q-toolbar-title", [
                    _vm._v(
                      "\n\t\t\t\t\t" +
                        _vm._s(_vm.$t("personalize_columns")) +
                        "\n\t\t\t\t"
                    )
                  ])
                ],
                1
              ),
              _c("div", { staticClass: "layout-padding" }, [
                _c(
                  "div",
                  { staticClass: "row gutter-md" },
                  _vm._l(_vm.columns, function(column, index) {
                    return _vm.changeContent(column)
                      ? _c(
                          "div",
                          { key: index, staticClass: "col-xs-12 col-sm-4" },
                          [
                            _c("q-checkbox", {
                              attrs: { label: _vm.$t(column.label) },
                              model: {
                                value: column.show,
                                callback: function($$v) {
                                  _vm.$set(column, "show", $$v)
                                },
                                expression: "column.show"
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e()
                  }),
                  0
                ),
                _c("div", { staticClass: "row reverse gutter-md q-mt-md" }, [
                  _c(
                    "div",
                    { staticClass: "col-xs-12 col-sm-3" },
                    [
                      _c("q-btn", {
                        staticClass: "fit",
                        attrs: {
                          icon: "fas fa-times",
                          color: "primary",
                          label: _vm.$t("close")
                        },
                        on: {
                          click: function($event) {
                            return _vm.saveColumns()
                          }
                        }
                      })
                    ],
                    1
                  )
                ])
              ])
            ],
            1
          )
        ],
        1
      ),
      _c(
        "q-dialog",
        {
          on: { ok: _vm.removeItem },
          scopedSlots: _vm._u([
            {
              key: "buttons",
              fn: function(props) {
                return [
                  _c("q-btn", {
                    attrs: { color: "primary", label: _vm.$t("cancel") },
                    on: {
                      click: function($event) {
                        _vm.confirm_remove = false
                      }
                    }
                  }),
                  _c("q-btn", {
                    attrs: { color: "negative", label: _vm.$t("remove") },
                    on: {
                      click: function($event) {
                        return _vm.removeItem()
                      }
                    }
                  })
                ]
              }
            }
          ]),
          model: {
            value: _vm.confirm_remove,
            callback: function($$v) {
              _vm.confirm_remove = $$v
            },
            expression: "confirm_remove"
          }
        },
        [
          _c("span", { attrs: { slot: "title" }, slot: "title" }, [
            _vm._v(_vm._s(_vm.$t("remove_user")))
          ]),
          _c("span", { attrs: { slot: "message" }, slot: "message" }, [
            _vm._v(_vm._s(_vm.$t("confirm_remove_user")))
          ])
        ]
      ),
      _c(
        "q-modal",
        {
          attrs: {
            "content-css": {
              minWidth: _vm.getMinWidth,
              maxWidth: _vm.getMaxWidth,
              minHeight: "80vh"
            }
          },
          model: {
            value: _vm.show_report,
            callback: function($$v) {
              _vm.show_report = $$v
            },
            expression: "show_report"
          }
        },
        [
          _c(
            "q-modal-layout",
            [
              _c(
                "q-toolbar",
                { attrs: { slot: "header" }, slot: "header" },
                [
                  _c("q-btn", {
                    attrs: {
                      flat: "",
                      round: "",
                      dense: "",
                      icon: "fas fa-times"
                    },
                    on: {
                      click: function($event) {
                        return _vm.hideReport()
                      }
                    }
                  }),
                  _c("q-toolbar-title", [
                    _vm._v(
                      "\n\t\t\t\t\t" +
                        _vm._s(this.selected_user.full_name) +
                        " - " +
                        _vm._s(this.selected_user.email) +
                        "\n\t\t\t\t"
                    )
                  ])
                ],
                1
              ),
              _c("div", { staticClass: "layout-padding" }, [
                _c("div", { staticClass: "row gutter-sm" }, [
                  _c(
                    "div",
                    { staticClass: "col-12" },
                    [
                      _c("reports", {
                        attrs: {
                          clear_data: _vm.clear_data,
                          show_report: _vm.show_report
                        }
                      })
                    ],
                    1
                  )
                ])
              ])
            ],
            1
          )
        ],
        1
      ),
      _c(
        "q-modal",
        {
          attrs: {
            "content-css": {
              minWidth: "100vw",
              maxWidth: "100vw",
              minHeight: "100vh"
            }
          },
          model: {
            value: _vm.show_report_users,
            callback: function($$v) {
              _vm.show_report_users = $$v
            },
            expression: "show_report_users"
          }
        },
        [
          _c(
            "q-modal-layout",
            [
              _c(
                "q-toolbar",
                { attrs: { slot: "header" }, slot: "header" },
                [
                  _c("q-btn", {
                    attrs: {
                      flat: "",
                      round: "",
                      dense: "",
                      icon: "fas fa-times"
                    },
                    on: {
                      click: function($event) {
                        _vm.show_report_users = false
                      }
                    }
                  }),
                  _c("q-toolbar-title", [
                    _vm._v(
                      "\n\t\t\t\t\t" + _vm._s(_vm.$t("reports")) + "\n\t\t\t\t"
                    )
                  ])
                ],
                1
              ),
              _c("div", { staticClass: "layout-padding" }, [
                _c(
                  "div",
                  {
                    staticStyle: {
                      position: "relative",
                      width: "100%",
                      height: "0px",
                      "padding-bottom": "56.25%"
                    }
                  },
                  [
                    _c("iframe", {
                      staticStyle: {
                        position: "absolute",
                        left: "0",
                        top: "0",
                        width: "100%",
                        height: "100%"
                      },
                      attrs: { src: _vm.report_url, frameborder: "0" }
                    })
                  ]
                )
              ])
            ],
            1
          )
        ],
        1
      ),
      _c(
        "q-modal",
        {
          attrs: {
            "content-css": {
              minWidth: "100vw",
              maxWidth: "100vw",
              minHeight: "100vh"
            }
          },
          model: {
            value: _vm.show_report_bi,
            callback: function($$v) {
              _vm.show_report_bi = $$v
            },
            expression: "show_report_bi"
          }
        },
        [
          _c(
            "q-modal-layout",
            [
              _c(
                "q-toolbar",
                { attrs: { slot: "header" }, slot: "header" },
                [
                  _c("q-btn", {
                    attrs: {
                      flat: "",
                      round: "",
                      dense: "",
                      icon: "fas fa-times"
                    },
                    on: {
                      click: function($event) {
                        _vm.show_report_bi = false
                      }
                    }
                  }),
                  _c("q-toolbar-title", [
                    _vm._v(
                      "\n\t\t\t\t\t" + _vm._s(_vm.$t("reports")) + "\n\t\t\t\t"
                    )
                  ])
                ],
                1
              ),
              _c("div", { staticClass: "layout-padding" }, [
                _c(
                  "div",
                  {
                    staticStyle: {
                      position: "relative",
                      width: "100%",
                      height: "0px",
                      "padding-bottom": "56.25%"
                    }
                  },
                  [
                    _c("iframe", {
                      staticStyle: {
                        position: "absolute",
                        left: "0",
                        top: "0",
                        width: "100%",
                        height: "100%"
                      },
                      attrs: { src: _vm.report_url, frameborder: "0" }
                    })
                  ]
                )
              ])
            ],
            1
          )
        ],
        1
      ),
      _c(
        "q-modal",
        {
          attrs: { "content-css": { minWidth: "80vw" } },
          model: {
            value: _vm.view_redeem_statement,
            callback: function($$v) {
              _vm.view_redeem_statement = $$v
            },
            expression: "view_redeem_statement"
          }
        },
        [
          _c(
            "q-modal-layout",
            [
              _c(
                "q-toolbar",
                { attrs: { slot: "header", color: "white" }, slot: "header" },
                [
                  _c(
                    "q-toolbar-title",
                    { staticClass: "text-black flex justify-between" },
                    [
                      _vm._v(
                        "\n\t\t\t\t\t\t\t\t\t" +
                          _vm._s(_vm.selected_user.full_name) +
                          " - " +
                          _vm._s(_vm.selected_user.email) +
                          "\n\t\t\t\t\t\t\t\t\t"
                      ),
                      _c("q-btn", {
                        directives: [
                          { name: "close-overlay", rawName: "v-close-overlay" }
                        ],
                        attrs: { flat: "", dense: "", icon: "close" }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "q-toolbar",
                {
                  staticClass: "justify-end",
                  attrs: { slot: "header", color: "white" },
                  slot: "header"
                },
                [
                  _c("q-search", {
                    staticClass: "q-my-md",
                    attrs: { color: "none", label: _vm.$t("search") },
                    on: {
                      keyup: function($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        ) {
                          return null
                        }
                        return _vm.fetchRedeemStatementByUser({
                          pagination: _vm.redeem_statement_pagination
                        })
                      }
                    },
                    model: {
                      value: _vm.search_statement,
                      callback: function($$v) {
                        _vm.search_statement = $$v
                      },
                      expression: "search_statement"
                    }
                  })
                ],
                1
              ),
              _c("q-table", {
                attrs: {
                  data: _vm.redeem_statements,
                  columns: _vm.redeem_statement_columns,
                  "row-key": "id",
                  flat: "",
                  pagination: _vm.redeem_statement_pagination,
                  loading: _vm.loading,
                  "no-data-label": _vm.$t("no_data_avaliable"),
                  "rows-per-page-options": [5, 10, 50, 100]
                },
                on: {
                  "update:pagination": function($event) {
                    _vm.redeem_statement_pagination = $event
                  },
                  request: _vm.fetchRedeemStatementByUser
                },
                scopedSlots: _vm._u([
                  {
                    key: "body-cell-status_from",
                    fn: function(props) {
                      return [
                        _c(
                          "q-td",
                          { attrs: { props: props } },
                          [
                            _c(
                              "q-chip",
                              {
                                staticClass: "full-width",
                                attrs: {
                                  icon: _vm.getRedeemStatusIcon(
                                    props.row.status_from
                                  ),
                                  color: _vm.getRedeemStatusColor(
                                    props.row.status_from
                                  )
                                }
                              },
                              [
                                _vm._v(
                                  "\n\t\t\t\t\t\t\t\t\t\t\t\t\t" +
                                    _vm._s(
                                      _vm.getRedeemStatus(
                                        props.row.status_from
                                      ) || "-"
                                    ) +
                                    "\n\t\t\t\t\t\t\t\t\t\t\t"
                                )
                              ]
                            )
                          ],
                          1
                        )
                      ]
                    }
                  },
                  {
                    key: "body-cell-status_to",
                    fn: function(props) {
                      return [
                        _c(
                          "q-td",
                          { attrs: { props: props } },
                          [
                            _c(
                              "q-chip",
                              {
                                staticClass: "full-width",
                                attrs: {
                                  icon: _vm.getRedeemStatusIcon(
                                    props.row.status_to
                                  ),
                                  color: _vm.getRedeemStatusColor(
                                    props.row.status_to
                                  )
                                }
                              },
                              [
                                _vm._v(
                                  "\n\t\t\t\t\t\t\t\t\t\t\t\t\t" +
                                    _vm._s(
                                      _vm.getRedeemStatus(
                                        props.row.status_to
                                      ) || "-"
                                    ) +
                                    "\n\t\t\t\t\t\t\t\t\t\t\t"
                                )
                              ]
                            )
                          ],
                          1
                        )
                      ]
                    }
                  }
                ])
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "q-dialog",
        {
          on: { ok: _vm.resetPassword },
          scopedSlots: _vm._u([
            {
              key: "buttons",
              fn: function(props) {
                return [
                  _c("q-btn", {
                    attrs: { color: "primary", label: _vm.$t("cancel") },
                    on: {
                      click: function($event) {
                        _vm.confirm_reset_password = false
                      }
                    }
                  }),
                  _c("q-btn", {
                    attrs: {
                      color: "negative",
                      label: _vm.$t("reset_password")
                    },
                    on: {
                      click: function($event) {
                        return _vm.resetPassword()
                      }
                    }
                  })
                ]
              }
            }
          ]),
          model: {
            value: _vm.confirm_reset_password,
            callback: function($$v) {
              _vm.confirm_reset_password = $$v
            },
            expression: "confirm_reset_password"
          }
        },
        [
          _c("span", { attrs: { slot: "title" }, slot: "title" }, [
            _vm._v(_vm._s(_vm.$t("reset_password")))
          ]),
          _c("span", { attrs: { slot: "message" }, slot: "message" }, [
            _vm._v(_vm._s(_vm.$t("confirm_send_reset_password_to_user_email")))
          ])
        ]
      ),
      _c(
        "q-dialog",
        {
          scopedSlots: _vm._u([
            {
              key: "buttons",
              fn: function(props) {
                return [
                  _c("q-btn", {
                    attrs: { color: "primary", label: _vm.$t("ok") },
                    on: {
                      click: function($event) {
                        _vm.show_success = false
                      }
                    }
                  })
                ]
              }
            }
          ]),
          model: {
            value: _vm.show_success,
            callback: function($$v) {
              _vm.show_success = $$v
            },
            expression: "show_success"
          }
        },
        [
          _c("span", { attrs: { slot: "title" }, slot: "title" }, [
            _vm._v(_vm._s(_vm.$t("reset_password")))
          ]),
          _c("span", { attrs: { slot: "message" }, slot: "message" }, [
            _vm._v(
              _vm._s(
                _vm.$t(
                  "an_email_was_sent_to_the_user_with_instructions_to_reset_his_password"
                )
              )
            )
          ])
        ]
      ),
      _c(
        "q-dialog",
        {
          attrs: { "prevent-close": "" },
          scopedSlots: _vm._u([
            {
              key: "buttons",
              fn: function(props) {
                return [
                  _c(
                    "div",
                    { staticClass: "row full-width q-mb-xs" },
                    [
                      _c("q-btn", {
                        staticClass: "offset-4 col-4",
                        attrs: { color: "positive", label: _vm.$t("ok") },
                        on: {
                          click: function($event) {
                            _vm.show_report_problem = false
                          }
                        }
                      })
                    ],
                    1
                  )
                ]
              }
            }
          ]),
          model: {
            value: _vm.show_report_problem,
            callback: function($$v) {
              _vm.show_report_problem = $$v
            },
            expression: "show_report_problem"
          }
        },
        [
          _c("span", { attrs: { slot: "title" }, slot: "title" }, [
            _vm._v(_vm._s(_vm.$t("report_download_failed")))
          ]),
          _c("div", { attrs: { slot: "message" }, slot: "message" }, [
            _c("span", { staticClass: "q-pa-xs" }, [
              _vm._v(_vm._s(_vm.$t("report_download_failed_exceeded_time")))
            ]),
            _c("p", { staticClass: "q-pa-xs" }, [
              _vm._v(_vm._s(_vm.$t("the_report_it_will_be_sent_to_your_email")))
            ])
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }